import { makeStyles } from '@mui/styles';

const useDropDownItemStyles = makeStyles({
	root: {
		alignItems: 'center',
		display: 'flex',
		flexFlow: 'row wrap',
		'&:not(:nth-child(1))': {
			marginTop: 12,
		},
	},
	codeContainer: {
		backgroundColor: '#1063AC',
		borderRadius: 16,
		color: 'white',
		fontFamily: 'Montserrat',
		fontSize: 14,
		fontWeight: 600,
		marginRight: 8,
		minWidth: 42,
		padding: '6px 12px',
		textAlign: 'center',
		width: 53,
	},
	textContainer: {
		maxWidth: 'calc(100% - 53px - 8px)',
	},
});

export default useDropDownItemStyles;
